import ArtistSellThroughRates from "./ArtistSellThroughRates";

export default ArtistSellThroughRates;
